import { useState, useEffect, useRef } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useRecoilValue, useRecoilState } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import ButtonForModal from "../../../../components/ButtonForModal";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { PencilSquareIcon, QrCodeIcon } from "@heroicons/react/24/solid";
import AddButton from "../../../../components/AddButton";
import DownloadButton from "../../../../components/DownloadButton";
import { FunnelIcon } from "@heroicons/react/24/solid";
import ReactTooltip from "react-tooltip";
import { useProducerCodeList } from "../hooks/useProducerCodeList";
import {
  isClearFilter,
  isResetStatus,
  prodCodeAddState,
  prodCodeCarrierName,
  prodCodeEditState,
  prodCodeFilterOpen,
  prodCodeModalRowData,
  prodCodeModalShowState,
  producerCodeMastercarrierId,
  producerCodeShowState,
  rowForEditProdCode,
  searchDataProducerCode,
  searchedProducerCodeTableData,
  selectedRowsProdCode,
  officeShowStateModal,
  oncloseOfficeToProdCodeModal,
  ofcToProducerCodeId,
  isRefetchExpandedModal,
  fromViewModal,
  fromRecentActivity,
  fromRedirection,
  prodCodeId,
  isShowFromEmployee,
  officeData,
} from "../atom";
import { useGetProducerCodeForEdit } from "../hooks/useGetProducerCodeForEdit";
import CloseIconButton from "../../../../components/CloseIconButton";
import useGetEmployees from "../hooks/useGetEmployees";
import { useStates } from "../../hooks/useStates";
import { ProdCodeExpandedModal } from "./ProducerCodeExpandedModal";
import { toast } from "../../../../components/toastNotification";
import { deleteProducerCodes } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import SubTableFilter from "../SubTableFilter";
import { ProducerCodeView } from "./ProducerCodeView";
import useSendEmail from "../hooks/useSendEmail";
import { useHistory } from "react-router-dom";
import {
  officeShowState,
  prodCodeToOfficeId,
} from "../../OfficeSettings/atoms/atoms";
import { mainSelectedTab } from "../../atoms";
import {
  employeeFromProducerCode,
  FromProdCodeToEmpData,
} from "../../Employees/Confie/atoms/atoms";
import { EmployeeTabs } from "../../../EmployeeTab/EmployeeTab";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useExportProducerCode from "../hooks/useExportProducerCode";
import { searchSubProducerCodeCriteria } from "../api/getProducerCodeSubSearch";

export const ProducerCodeFullGrpTbl = ({ rowData }) => {
  const args = rowData;
  const {
    data: producerCodeData,
    isLoading: isproducerCodeDataLoading,
    refetch: refetchProdCodeList,
  } = useProducerCodeList(args);

  const carrierName = rowData?.carrierName;
  const { mutate: prodCodeForEdit } = useGetProducerCodeForEdit();
  const [isEditState, setIsEditState] = useRecoilState(prodCodeEditState);
  const [, setRowForEdit] = useRecoilState(rowForEditProdCode);
  const [, setViewProdCodes] = useRecoilState(producerCodeShowState);
  const [viewProdCodeModal, setViewProdCodeModal] = useRecoilState(
    prodCodeModalShowState
  );
  const [, setProdCodeEmpId] = useRecoilState(FromProdCodeToEmpData);
  const [, setMasterCarrierId] = useRecoilState(producerCodeMastercarrierId);
  const [, setCarrierName] = useRecoilState(prodCodeCarrierName);
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsProdCode);
  const [, setIsAddState] = useRecoilState(prodCodeAddState);
  const [rowViewData, setRowViewData] = useRecoilState(prodCodeModalRowData);
  const [isBulkSelected] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [, setOpenModalCDRC] = useState(false);
  const [, setSelectedOption] = useState([]);
  const [resetStatus, setResetStatus] = useRecoilState(isResetStatus);
  const [clearFilter, setClearFilter] = useRecoilState(isClearFilter);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filteredProducerCodeData, setFilteredproducerCodeData] = useState([]);
  const [subFilterLoading, setIsSubFilterLoading] = useState(false);
  const [, setsearchProducerCodeInputsData] = useRecoilState(
    searchedProducerCodeTableData
  );
  const [searchInputsData, setSearchInputsData] = useRecoilState(
    searchDataProducerCode
  );

  const [prodCodeData, setProdCodeData] = useState([]);
  const [, setViewFromHierarchy] = useRecoilState(employeeFromProducerCode);
  const user = useRecoilValue(accountAtom);
  const [filter, setFilter] = useRecoilState(prodCodeFilterOpen);
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_edit;
  const addPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_add;
  const viewPermissionEmp =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view;
  const deletePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_producercode_delete;
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setOfficeData] = useRecoilState(officeData);
  const [, setShowState] = useRecoilState(officeShowState);
  const [isRefetchModal, setIsRefetchModal] = useRecoilState(
    isRefetchExpandedModal
  );
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [getProdCodeToOfficeId] = useRecoilState(prodCodeToOfficeId);
  const [fromRecents] = useRecoilState(fromRecentActivity);
  const [showModalFromRedi, setShowModalFromRedi] =
    useRecoilState(fromRedirection);
  const [carrierProdCodeId] = useRecoilState(prodCodeId);
  const { data: issuedTo } = useGetEmployees();
  const IssuedToOptions = issuedTo?.map((x) => {
    return {
      label: x.fullname + " - " + x.employeenumber,
      value: x.employeeId?.toString(),
    };
  });

  const allDropdownOption = {
    label: "ALL",
    value: "ALL",
  };

  const { data: canSell } = useStates();

  const stateOpt = canSell?.map((x) => {
    return {
      label: x.state,
      value: x.state?.toString(),
    };
  });

  const canSellOpt = stateOpt && [allDropdownOption, ...stateOpt];

  useEffect(() => {
    if (showModalFromRedi && prodCodeData?.length > 0) {
      var id = carrierProdCodeId ?? 0;
      var filteredData = prodCodeData?.filter(
        (x) => x.carrierProducerCodeId === id
      );
      setShowModalFromRedi(false);
      onClickCProducercode(filteredData[0] ?? []);
    }
  }, [showModalFromRedi, prodCodeData]);

  const handleEditButton = (rowData) => {
    setOfficeData({
      distributionChannel: rowData.distributionChannel,
      officeStatusDetailsName: rowData.officeStatusDetailsName,
      relatedOfficeCode: rowData.relatedOfficeCode,
    });
    prodCodeForEdit(rowData.carrierProducerCodeId, {
      onSuccess: (res) => {
        const issuedToValues = res?.issuedTo?.split(",");
        const filteredIssuedTo = issuedToValues?.map((x) =>
          IssuedToOptions?.filter((c) => c?.value === x)
        );
        const issuedToVal = filteredIssuedTo?.map((x) => x?.map((c) => c)[0]);

        const canSellValues = res?.crossSale?.split(",");
        const filteredCanSell = canSellValues?.map((x) =>
          canSellOpt?.filter((c) => c.value === x)
        );
        const canSellVal = filteredCanSell?.map((x) => x?.map((c) => c)[0]);

        setRowForEdit({
          ...res,
          issuedTo: res.issuedTo ? issuedToVal : "",
          crossSale: res.crossSale ? canSellVal : "",
          isActive: res.isActive === true ? true : false,
        });
        setIsEditState(true);
      },
    });
  };

  const oldValues = {
    Carrier: [],
    State: [],
    Offices: [],
    ProducerCode: "",
    MAProducerCode: "",
    AcquisitionName: "",
  };

  const [ShowFromOffice, setShowFromOffice] =
    useRecoilState(officeShowStateModal);
  const [showFromEmployee, setShowFromEmployee] =
    useRecoilState(isShowFromEmployee);
  const [showFromOfficeClose, setShowFromOfficeClose] = useRecoilState(
    oncloseOfficeToProdCodeModal
  );

  const [forModal, setShowFormModal] = useRecoilState(fromViewModal);
  const [producerCodeId] = useRecoilState(ofcToProducerCodeId);
  const [oldFilteredValue] = useState(oldValues);

  useEffect(() => {
    setSelectedRows([]);
    setSelectedOption([]);
  }, []);

  const history = useHistory();
  const tableRef = useRef(0);

  useEffect(() => {
    if (Array.isArray(producerCodeData)) {
      setProdCodeData(
        producerCodeData?.map((data) => ({
          ...data,
          isActive: data.isActive ? "Active" : "Inactive",
        }))
      );
    }
    if (isRefetchModal) {
      refetchProdCodeList();
      setIsRefetchModal(false);
    }
    if (forModal && producerCodeData?.length > 0) {
      const pageNumber = localStorage.getItem("groupedPage");
      tableRef.current.dataManager.currentPage = pageNumber;
      const filteredData = producerCodeData?.filter(
        (x) => x.carrierProducerCodeId === Number(producerCodeId)
      )[0];
      setRowViewData(filteredData);
      setViewProdCodeModal(true);
    }
    if (showFromOfficeClose && producerCodeData?.length > 0) {
      const pageNumber = localStorage.getItem("groupedPage");
      tableRef.current.dataManager.currentPage = pageNumber;
      const filteredData = producerCodeData?.filter(
        (x) => x.carrierProducerCodeId === Number(producerCodeId)
      )[0];
      setRowViewData(filteredData);
      setShowFromOfficeClose(false);
      setFilteredproducerCodeData(filteredData);
    }
  }, [producerCodeData]);

  const searchMutation = useMutation(
    (searchInputsData) => {
      return searchSubProducerCodeCriteria({
        ...searchInputsData,
        carrierProducerCodes: args,
      });
    },
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        if (!res || res.length === 0 || res === null) {
          setFilteredproducerCodeData([]);
        } else {
          setFilteredproducerCodeData(
            res?.map((responseData) => ({
              ...responseData,
            }))
          );
        }
        setIsSubFilterLoading(false);
      },
      onError: (error) => {
        setIsSubFilterLoading(false);
      },
    }
  );

  const searchProducerCodeCriteriaEntry = () => {
    localStorage.removeItem("NotifFilter");
    localStorage.removeItem("ModuleFilter");

    if (!resetStatus) {
      setSearchInputsData({
        ...searchInputsData,
        selectedCarrierName: carrierName,
      });

      if (
        !searchInputsData?.CarrierName?.length &&
        !searchInputsData?.OfficeName?.length &&
        !searchInputsData?.State?.length &&
        !searchInputsData?.ProducerCode &&
        !searchInputsData?.MAProducerCode &&
        !searchInputsData?.AcquisitionName &&
        !searchInputsData?.BillingId &&
        !searchInputsData?.selectedFranchiseConfie &&
        !searchInputsData?.DistributionChannelId &&
        !searchInputsData?.Status?.length
      ) {
        toast.fire("Error", "Search fields must be filled!", "error");
      } else {
        setFilterStatus(true);
        searchMutation.mutate(searchInputsData);
      }
    } else {
      // For Reset
      setSearchInputsData([]);
      setsearchProducerCodeInputsData([]);
    }
  };

  const handleSearchInputs = (fieldName, selectedValue) => {
    setResetStatus(false);
    if (fieldName !== "Refresh") {
      setSearchInputsData((searchInputsData) => ({
        ...searchInputsData,
        [fieldName]: selectedValue,
      }));
    } else {
      setResetStatus(true);
      setFilteredproducerCodeData([]);
      setsearchProducerCodeInputsData([]);
    }
  };

  const handleBulkDelete = () => {
    const ids = selectedRows?.map((row) => row.carrierProducerCodeId);
    setSelectedRows([]);
    setOpenModalDelete(false);
    deleteProduceCodeMutation.mutate(ids);
  };

  const { mutateAsync: sendProdCodeEmail } = useSendEmail();
  const queryClient = useQueryClient();

  const deleteProduceCodeMutation = useMutation(
    (producerCodeIds) => deleteProducerCodes(producerCodeIds, user?.username),
    {
      onSuccess: (res) => {
        if (res.statusText !== "Bad Request") {
          queryClient.invalidateQueries("ProducerCodeList");
          sendProdCodeEmail(res.data, {
            onSuccess: (res) => {
              if (res) {
                if (res.status === 400) {
                  toast.fire(
                    "Success",
                    "Producer Codes Deactivated Successfully, but failed in sending email",
                    "warning"
                  );
                } else {
                  toast.fire(
                    "Success",
                    `Producer Codes were Deactivated successfully`,
                    "success"
                  );
                }
              }
              setOpenModalDelete(false);
              setOpenModalCDRC(false);
              setSelectedRows([]);
              setSelectedOption([]);
            },
          });
        } else {
          setOpenModalDelete(false);
          setOpenModalCDRC(false);
          setSelectedRows([]);
          setSelectedOption([]);
          toast.fire("Warning", res.data, "warning");
        }
      },
      onError: (error) => {
        if (
          error.response.data.message === "Failed sending of email" ||
          error.response.data.message === "Failed inserting of notification"
        ) {
          queryClient.invalidateQueries("ProducerCodeList");
          toast.fire(
            "Success",
            "Producer Codes were Deactivated successfully, but " +
              error.response.data.message,
            "warning"
          );
          setOpenModalDelete(false);
          setSelectedRows([]);
          setSelectedOption([]);
        } else {
          toast.fire(
            "Bulk Deactivating of Producer Codes failed",
            "Server Error: Cannot Inactivate ProducerCode",
            "error"
          );
          setOpenModalDelete(false);
          setSelectedRows([]);
          setSelectedOption([]);
        }
      },
    }
  );

  const onClickCProducercode = (rowData) => {
    setViewProdCodeModal(true);
    setRowViewData({ ...rowData });
  };

  const onClickProducername = (idEmployee, masterCarrierID) => {
    const url = "/employeetab/employee";
    localStorage.setItem(
      "groupedPage",
      tableRef.current.dataManager.currentPage
    );
    localStorage.setItem(
      "employeeRedirectState",
      JSON.stringify({
        pathname: url,
        employeeNumber: idEmployee,
        masterCarrierId: masterCarrierID,
        action: "ProducerName",
      })
    );
    history.push({
      pathname: url,
    });

    window.location.reload();
    setProdCodeEmpId(idEmployee);
    let userTabs = [
      {
        to: "",
      },
    ];
    [...EmployeeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });

    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setViewFromHierarchy(true);
    setSelectedIndex(index);
  };

  const onClickCloseProducercode = () => {
    if (ShowFromOffice) {
      const url = "/officesettings/officesetting";
      history.push({
        pathname: "/officesettings/officesetting",
        state: {
          officeId: getProdCodeToOfficeId,
          action: "ProdCodeToOfficeClose",
        },
      });
      window.location.reload();
      let userTabs = [
        {
          to: "",
        },
      ];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );

        if (temp.length > 0) userTabs.push(tabs.to);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowState(true);
    }

    const employeeId = localStorage.getItem("employeeId");
    if (showFromEmployee || employeeId) {
      const url = "/employeetab/employee";
      history.push({
        pathname: url,
        state: {
          employeeId: employeeId,
          action: "CloseFromProducerCode",
        },
      });
      window.location.reload();
      let userTabs = [
        {
          to: "",
        },
      ];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );

        if (temp.length > 0) userTabs.push(tabs.to);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      localStorage.removeItem("employeeId");
    }

    setShowFromOfficeClose(false);
    setViewProdCodeModal(false);
    setShowFormModal(false);
    localStorage.removeItem("groupedPage");
  };

  const onClickAssociatedTo = (officeCode, masterCarrierId) => {
    const url = "/officesettings/officesetting";
    localStorage.setItem(
      "groupedPage",
      tableRef.current.dataManager.currentPage
    );
    localStorage.setItem(
      "officeRedirectState",
      JSON.stringify({
        pathname: url,
        officeCode: officeCode,
        masterCarrierId: masterCarrierId,
        action: "ProducerAssociatedTo",
        showFromProd: true,
        fromRecent: fromRecents,
      })
    );
    history.push({
      pathname: url,
    });
    window.location.reload();
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });

    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setViewFromHierarchy(true);
    setSelectedIndex(index);
  };

  const mappingStatus = {
    Inactive: "inact.",
    Exception: "expt.",
    True: "yes",
    False: "no",
  };

  const materialColumns = [
    {
      field: "producerCode",
      render: (rowData) => {
        return (
          <div className="cursor-pointer flex flex-col justify-end w-full text-sm">
            <div
              className="blueAndBold underline uppercase"
              onClick={() => onClickCProducercode(rowData)}
            >
              {rowData.producerCode ? rowData.producerCode : "unspecified"}
            </div>
            {rowData.masterCarrierID === 20 ? (
              <div className="mainLabeltextColor">Princeton Code</div>
            ) : (
              <div className="mainLabeltextColor">Producer Code</div>
            )}
          </div>
        );
      },
    },
    {
      field: "producerSubCode",
      render: (rowData) => {
        return (
          <div className=" flex flex-col text-sm">
            <div className="font-medium">
              {rowData.producerSubCode ? (
                <span className=" font-bold-400 uppercase text-xs">
                  {rowData.producerSubCode}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>

            <div className="mainLabeltextColor">SubCode</div>
          </div>
        );
      },
    },
    {
      field: "maProducerCode",
      render: (row) => {
        return (
          <div className=" flex flex-col text-sm">
            <div className="font-medium">
              {!!row.mAproducerCode ? (
                <span className=" font-bold-400 uppercase text-xs">
                  {row.mAproducerCode}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor">M&A Producer Code</div>
          </div>
        );
      },
    },
    {
      field: "brand",
      render: (row) => {
        return (
          <div className=" flex flex-col text-sm">
            <div className="font-medium">
              {row.brand ? (
                <span className=" font-bold-400 uppercase text-xs">
                  {row.brand}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
            <div className="mainLabeltextColor">Agency</div>
          </div>
        );
      },
    },
    {
      field: "combinedSearchField",

      customFilterAndSearch: (term, row) => {
        const searchableText = [
          row.officeName,
          row.officeCode,
          row.address,
          row.state,
          row.city,
          row.zipCode,
          row.producerName,
        ]
          .filter(Boolean)
          .join(" ");
        return searchableText.toLowerCase().includes(term.toLowerCase());
      },

      render: (row) =>
        row.associatedTo === "Producer" ? (
          <div className="flex  flex-col">
            <div>
              <ReactTooltip place="right" effect="solid" type="info" />
              {userPermissions.includes(viewPermissionEmp) ? (
                row.producerName !== "" ? (
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      onClickProducername(row.producer, row.masterCarrierID);
                    }}
                  >
                    <span className=" font-bold-400 uppercase">
                      <span className="blueAndBold underline uppercase">
                        {row.producerName}
                      </span>
                    </span>
                  </div>
                ) : (
                  <span className="undefineTextColor">unspecified</span>
                )
              ) : row.producerName !== "" ? (
                <div
                  data-tip={
                    "Contact your System Administrator to secure access to employee module."
                  }
                  className="cursor-pointer"
                >
                  <span>{row.producerName}</span>
                </div>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>

            <div className="mainLabeltextColor">Associated To</div>
          </div>
        ) : row.associatedTo === "Office" ? (
          <div className="flex  flex-col">
            <div
              className="cursor-pointer"
              onClick={() => {
                onClickAssociatedTo(row.officeCode, row.masterCarrierID);
              }}
            >
              <div>
                <span className=" font-bold-400 uppercase">
                  <span className="text-xs blueAndBold underline uppercase">
                    {row.officeCode} - {row.officeName}
                  </span>
                </span>
              </div>
              <div className="text-xs blueAndBold underline uppercase">
                {" "}
                {row.address}
                {", "} {row.city}
                {", "} {row.state}
                {", "} {row.zipCode}
              </div>
            </div>
            <div className="mainLabeltextColor">Associated To</div>
          </div>
        ) : (
          <div className="flex  flex-col">
            <div className="undefineTextColor">unspecified</div>
            <div className="mainLabeltextColor">Not Associated</div>
          </div>
        ),
    },
    { field: "program", hidden: true },
    { field: "mga", hidden: true },
    { field: "distributionChannelName", hidden: true },
    { field: "codeLevel", hidden: true },
    { field: "franchiseTypeName", hidden: true },
    {
      field:
        "program" ||
        "mga" ||
        "distributionChannelName" ||
        "codeLevel" ||
        "franchiseTypeName",
      render: (row) => (
        <div className=" flex  flex-col item-center ">
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">Program: </div>
            <div>
              {row.program ? (
                <span className=" font-bold-400 text-xxs uppercase">
                  {row.program}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">MGA: </div>
            <div>
              {row.mga ? (
                <span className=" font-bold-400 text-xxs uppercase">
                  {row.mga}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">Dist. Channel: </div>
            <div className="font-medium">
              {row.distributionChannel || row.officeTypeName ? (
                <span className=" font-bold-400 text-xxs uppercase">
                  {row.isFranchise === true
                    ? row.officeTypeName
                    : row.distributionChannel}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">Code Level: </div>
            <div className="font-medium">
              {row.codeLevel ? (
                <span className="font-bold-400 text-xxs uppercase">
                  {row.codeLevel}
                </span>
              ) : (
                <span className="undefineTextColor">unspecified</span>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="mainLabeltextColor mt-1">Franchise Type: </div>
            {row.franchiseTypeName ? (
              <span className="font-bold-400 text-xxs uppercase">
                {row.franchiseTypeName}
              </span>
            ) : (
              <span className="undefineTextColor">unspecified</span>
            )}
          </div>
        </div>
      ),
      width: "15%",
    },

    {
      field: "isActive",
      render: (row) => (
        <div className=" flex flex-col item-center">
          <div className="flex items-center space-x-2">
            <label
              style={{
                background:
                  row.isActive && row.isActive !== "Inactive" && "#0C77BD",
              }}
              className="react-switch-label text-center"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap flex justify-center items-center w-full  ">
                {row.isActive === "Inactive" || row.isActive === false
                  ? "No"
                  : "Yes"}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">is Active</div>
          </div>
          <div className="flex items-center space-x-2">
            <label
              style={{ background: row.isSuspended && "#0C77BD" }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap flex justify-center items-center w-full">
                {row.isSuspended ? "Yes" : "No"}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">is Suspended</div>
          </div>
          <div className="flex items-center space-x-2">
            <label
              style={{ background: row.isFranchise && "#0C77BD" }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap  flex justify-center items-center w-full">
                {row.isFranchise ? "Yes" : "No"}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">is Franchise</div>
          </div>
          <div className="flex items-center space-x-2">
            <label
              style={{
                background:
                  mappingStatus[row.cdrcStatus] === "yes" && "#0C77BD",
              }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase whitespace-nowrap flex justify-center items-center w-full">
                {mappingStatus[row.cdrcStatus]}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">
              <span>mapped To Cdrc</span>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <label
              style={{
                background:
                  mappingStatus[row.keeperStatus] === "yes" && "#0C77BD",
              }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap flex justify-center items-center w-full ">
                {mappingStatus[row.keeperStatus]}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">mapped To Keeper</div>
          </div>

          <div className="flex items-center space-x-2">
            <label
              style={{
                background: mappingStatus[row.aL3Status] === "yes" && "#0C77BD",
              }}
              className="react-switch-label"
              htmlFor={`react-switch-new`}
            >
              <div className="text-xxs font-normal text-white uppercase  whitespace-nowrap flex justify-center items-center w-full  ">
                {mappingStatus[row.aL3Status]}
              </div>
            </label>
            <div className="mainLabeltextColor mt-1">mapped To AL3</div>
          </div>
        </div>
      ),
    },

    {
      center: true,
      render: (rowData) => {
        return (
          <div className=" flex justify-center">
            {userPermissions.includes(editPermission) ? (
              <ButtonForModal
                className="border-quaternary text-white bg-quaternary "
                onClick={() => {
                  handleEditButton(rowData);
                  setCarrierName(rowData?.carrierName);
                }}
                isDisabled={false}
              >
                <PencilSquareIcon className="h-4 w-4" />
                Edit
              </ButtonForModal>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
  ];

  //#region Download
  const { mutateAsync: exportProdCode, isLoading: isLoadingExport } =
    useExportProducerCode();

  const downloadData = () => {
    if (tableRef.current.dataManager.searchText !== "") {
      return tableRef.current.dataManager.searchedData;
    } else if (filteredProducerCodeData?.length > 0 || (filteredProducerCodeData?.length === 0 && filterStatus)) {
      return filteredProducerCodeData;
    } else {
      return producerCodeData;
    }
  };

  const downloadProducerCode = async () => {
    const data = downloadData();
    const converted = data.map((x) => ({
      ...x,
      isActive: x.isActive === "Active", // convert to boolean
    }));

    await exportProdCode(converted).catch((err) => {
      if (err?.message.toLowerCase() === "no data result") {
        toast.fire(
          "No Data to Export",
          "There are no records matching the selected filters",
          "warning"
        );
      }
    });
  };
  //#endregion

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRows?.length
    } ${
      selectedRows
        ? selectedRows.length > 1
          ? "Producer Codes"
          : "Producer Code"
        : undefined
    } ?`}</div>
  );

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map(({ tableData, ...rows }) => {
        return rows;
      });

    setSelectedRows(forDelete);
  };

  return (
    <div className="relative text-xs box-shadow border-primary border-l-2">
      <div>
        {viewProdCodeModal && (
          <ProducerCodeView
            showFullView={viewProdCodeModal}
            closeFullView={() => onClickCloseProducercode()}
            producerCodeId={rowViewData}
            handleEditButton={handleEditButton}
            data={rowViewData}
          >
            <ProdCodeExpandedModal data={rowViewData} tableRef={tableRef} />
          </ProducerCodeView>
        )}
      </div>
      <div>
        <div className="ml-4 mr-4 z-10">
          <CloseIconButton
            onClick={() => {
              setViewProdCodes(false);
              setShowFormModal(false);
              setShowFromOffice(false);
              setShowFromEmployee(false);
              setShowFromOfficeClose(false);
              localStorage.removeItem("tablePage");
              localStorage.removeItem("groupedPage");
            }}
          />
          <div className="flex justify-between tems-center space-x-4 ">
            <div className="flex items-center space-x-2 py-2">
              <QrCodeIcon className="text-white bg-blue-500 rounded-md h-10 w-10 p-1" />
              <div className="text-xs text-gray-600 font-medium">
                <label>Producer Code</label>
                <div className="flex items-center font-bold-400 blueAndBold">
                  {args?.carrierName}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4">
                  <div>{args?.masterCarrierAddress}</div>
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center gap-2">
              {userPermissions.includes(addPermission) && (
                <AddButton
                  buttonText="Add"
                  onClick={() => {
                    setIsAddState(true);
                    setMasterCarrierId(args?.masterCarrierId);
                    setCarrierName(args?.carrierName);
                    setRowForEdit((prev) => ({...prev, carrierId: args?.masterCarrierId, masterCarrierId: args?.masterCarrierId }));
                  }}
                />
              )}
              <div className="box-content">
                <DownloadButton
                  buttonValue={
                    isLoadingExport ? "Downloading..." : "Download File"
                  }
                  disabled={isLoadingExport}
                  onClick={() => downloadProducerCode()}
                />
              </div>
            </div>
          </div>
          <div className="border-secondary border-b-2" />
        </div>
        <div className="px-4 pt-4 pb-3">
          <button
            className="hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
            gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
            onClick={() => {
              setFilter(!filter);
            }}
          >
            <div>Filter By</div>
            <FunnelIcon className="h-3 w-3" />
          </button>
        </div>
        <div className="flex justify-start">
          {filter && (
            <SubTableFilter
              oldFilteredValue={oldFilteredValue}
              clearFilter={clearFilter}
              setClearFilter={setClearFilter}
              mutationFilter={searchMutation}
              handleSearchInputs={handleSearchInputs}
              setFilterStatus={setFilterStatus}
              setFilteredproducerCodeData={setFilteredproducerCodeData}
              searchProducerCodeCriteriaEntry={searchProducerCodeCriteriaEntry}
              setIsSubFilterLoading={setIsSubFilterLoading}
            />
          )}
          <div className="w-full overflow-x-auto">
            {userPermissions.includes(deletePermission) ? (
              <div className="text-secondary px-4 pb-2 italic text-xs3 ">
                {!isEditState ? (
                  <div>
                    <p className="self-center font-bold italic inline-block mr-1">
                      Note:{" "}
                    </p>
                    Tick the box to deactivate some data.
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ) : (
              ""
            )}
            <div className="mx-4 rounded-lg box-shadow mb-4">
              <MaterialTableTS
                isLoading={
                  subFilterLoading
                    ? subFilterLoading
                    : isproducerCodeDataLoading
                    ? true
                    : false
                }
                columns={materialColumns ?? []}
                data={
                  filteredProducerCodeData?.length > 0
                    ? filteredProducerCodeData
                    : fromRecents
                    ? producerCodeData
                    : !filterStatus
                    ? prodCodeData
                    : []
                }
                paging={true}
                pageSize={10}
                headerStyle={{
                  display: "none",
                }}
                selection={userPermissions.includes(deletePermission)}
                setConfirmModalOpen={setOpenModalDelete}
                onSelectionChange={handleSelectedRowsChange}
                selectedRows={selectedRows}
                tableRef={tableRef}
                toolbarSearch={true}
                searchFieldAlignment="left"
                showToolbar={true}
              />
            </div>
          </div>
        </div>
      </div>
      <ConfirmBoxDelete
        ModalTitle="Deactivate Producer Code"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={isBulkSelected ? handleBulkDelete : handleBulkDelete}
        cancelButtonRef={undefined}
      />
    </div>
  );
};
